import { useQuery } from "@tanstack/react-query";
import * as api from "./api";

// Mismo criterio que `vehicles/vehicleQueries.ts` → `useMaintenances`: sin
// invalidación propia porque esta vista no muta nada (RF-MIE-10 y el alta/
// edición por vehículo siguen fuera de este módulo).
export const useMemberMaintenances = (memberId: string) =>
  useQuery({
    queryKey: ["portal", "member-maintenances", memberId],
    queryFn: () => api.listMemberMaintenances(memberId),
    enabled: Boolean(memberId),
  });
